import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { environment } from 'environments/environment';



/* export const environment = {
  production: false,
  appVersion: '1.19.13'
};
 */

@Component({
  selector: 'app-kv-toast',
  template: `
    <p-toast>
      <ng-template pTemplate="message" let-message>
        <div class="kv-toast corner-label-container">

          <div class="kv-toast-content">
            <div class="kv-toast-summary">{{ message.summary }}</div>
            <div class="kv-toast-detail">{{ message.detail }}</div>
          </div>

            <span
          class="corner-label corner-label--top-right"
          [ngClass]="{
            'success': message.severity === 'success',
            'error': message.severity === 'error',
            'warn': message.severity === 'warn'
          }">
          v{{ appVersion }}
        </span>

        </div>
      </ng-template>
    </p-toast>
  `,
  styleUrls: ['./toastNotification.component.css']
})
export class ToastNotificationComponent implements OnInit {


    appVersion = environment.VERSION;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
   /*  this.http.get('/package.json')
      .subscribe((data: any) => {
        this.appVersion = data.version;
        console.log(this.appVersion);
      });*/
  }


}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/toastNotification/toastNotification.component.ts